export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-foreground-800 to-foreground-900 p-8 md:p-14">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-accent-500"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-primary-500"></div>
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="flex items-center gap-3 mb-3 justify-center lg:justify-start">
                <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-mail-send-line text-accent-400 text-xl"></i>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading text-background-50">联系我们</h2>
              </div>
              <p className="text-background-50/70 text-base md:text-lg leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                如果您有漫画投稿、商务合作或任何问题咨询，欢迎通过以下方式联系我们。羞羞漫画期待与每一位创作者和读者共同成长。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <span className="flex items-center gap-2 text-background-50/80 text-sm whitespace-nowrap">
                  <i className="ri-mail-line text-accent-400"></i>
                  contact@xiuxiumanhua.com
                </span>
                <span className="flex items-center gap-2 text-background-50/80 text-sm whitespace-nowrap">
                  <i className="ri-wechat-line text-accent-400"></i>
                  微信公众号：羞羞漫画
                </span>
                <span className="flex items-center gap-2 text-background-50/80 text-sm whitespace-nowrap">
                  <i className="ri-timer-line text-accent-400"></i>
                  工作日 9:00 - 18:00
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 w-40 h-40 sm:w-52 sm:h-52">
              <div className="w-full h-full rounded-2xl bg-background-50/10 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-6xl text-accent-400"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}